import * as React from "react";
import { SpirometrySessionMetadata, SpirometryAnalysisSet, OverreadChallengeStatusEnum, OverreadStatusIdEnum, ChallengeableAnalysisSet } from '../../misc/api/apiTypes';
import { AnalysisAcceptabilityStatus } from "../../misc/components/analysis/AnalysisAcceptabilityStatus";

export const GetOverreadAnalysisSet = (session: SpirometrySessionMetadata): SpirometryAnalysisSet => {
    return session.AnalysisSets.find(spAs => spAs.Type.Id === "SAS_OVERREAD");
}

export const GetSiteAnalysisSet = (session: SpirometrySessionMetadata): SpirometryAnalysisSet => {
    return session.AnalysisSets.find(spAs => spAs.Type.Id === "SAS_SITE");
}

export interface ChallengeStatusProps {
    status: string;
    challengeStatus: string;
}

export const ChallengeStatus = ({ status, challengeStatus }: ChallengeStatusProps) => <><AnalysisAcceptabilityStatus value={status} /><br /><span className="label label-danger">{challengeStatus}</span></>;
export const ChallengeStatusCoded = ({ status, challengeStatus }: ChallengeStatusProps) => {
    var statusName = '';
    var challengeStatusName = ''
    switch (status) {
        case OverreadStatusIdEnum.Pending:
            statusName = 'Pending';
            break;
        case OverreadStatusIdEnum.Accepted:
            statusName = 'Accepted';
            break;
        case OverreadStatusIdEnum.Rejected:
            statusName = 'Rejected';
            break;
        default:
            statusName = 'Not started';
    }
    switch (challengeStatus) {
        case OverreadChallengeStatusEnum.Challenged:
            challengeStatusName = 'Challenged';
            break;
        case OverreadChallengeStatusEnum.NotChallenged:
            challengeStatusName = 'Not Challenged';
            break;
        default:
            challengeStatusName = 'Not Challenged';
    }
    return <>{statusName} <span className="label label-danger">{challengeStatusName}</span></>;
}

export const GetOverreadSessionStatus = (session: SpirometrySessionMetadata): React.ReactNode => {
    const overreadAnalysisSet = GetOverreadAnalysisSet(session);

    if (overreadAnalysisSet) {
        if (!session.ChallengeIsClosed && session.ChallengeStatusId === OverreadChallengeStatusEnum.Challenged && (overreadAnalysisSet.StatusId === OverreadStatusIdEnum.Accepted || overreadAnalysisSet.StatusId === OverreadStatusIdEnum.Rejected)) {
            return <ChallengeStatus status={overreadAnalysisSet.Status.Name} challengeStatus={session.ChallengeStatus} />;
        }

        return <AnalysisAcceptabilityStatus value={overreadAnalysisSet.StatusId} />;
    } else {
        return session.Status;
    }
}

export const GetSiteSessionStatus = (session: SpirometrySessionMetadata): React.ReactNode => {
    const siteAnalysisSet = GetSiteAnalysisSet(session);

    if (siteAnalysisSet) {
        return <AnalysisAcceptabilityStatus value={siteAnalysisSet.StatusId} />;
    } else {
        return session.Status;
    }
}

export const GetAnalysisStatus = (overreadAnalysisSet: ChallengeableAnalysisSet): React.ReactNode => {
    if (!overreadAnalysisSet.ChallengeIsClosed && overreadAnalysisSet.ChallengeStatusId === OverreadChallengeStatusEnum.Challenged && (overreadAnalysisSet.StatusId === OverreadStatusIdEnum.Accepted || overreadAnalysisSet.StatusId === OverreadStatusIdEnum.Rejected)) {
        return <ChallengeStatus status={overreadAnalysisSet.StatusId} challengeStatus={overreadAnalysisSet.ChallengeStatus} />;
    }

    return <AnalysisAcceptabilityStatus value={overreadAnalysisSet.StatusId} />;
}
